import { TableCell } from '@mui/material';

import { GDMTableCellComponent } from './GDMTableCell.type';

/* TODO: Implement component using GDM default design */
const GDMTableCell: GDMTableCellComponent = props => <TableCell {...props} />;

export default GDMTableCell;
